// extracted by mini-css-extract-plugin
export default {"form":"Form_form__i7zGo","input":"Form_input__ej6SE","title":"Form_title__FBC22","specialTitle":"Form_specialTitle__WhTwe"};